import { get, put } from '@api';
import { Store } from 'react-notifications-component';
import {
  COMMON_DATA_UPDATE_FAIL,
  COMMON_DATA_UPDATE_SUCCESS,
} from '../../constants/notification-settings';

export const FETCH_ORDER_STATUS_MAP_START = 'FETCH_ORDER_STATUS_MAP_START';
export const FETCH_ORDER_STATUS_MAP_SUCCESS = 'FETCH_ORDER_STATUS_MAP_SUCCESS';
export const FETCH_ORDER_STATUS_MAP_FAIL = 'FETCH_ORDER_STATUS_MAP_FAIL';
export const UPDATE_ORDER_STATUS_MAP_SUCCESS = 'UPDATE_ORDER_STATUS_MAP_SUCCESS';

const fetchOrderStatusMapStart = (axis) => ({
  type: FETCH_ORDER_STATUS_MAP_START,
  axis,
});

const fetchOrderStatusMapSuccess = (axis, payload) => ({
  type: FETCH_ORDER_STATUS_MAP_SUCCESS,
  axis,
  payload,
});

const fetchOrderStatusMapFail = (axis, error) => ({
  type: FETCH_ORDER_STATUS_MAP_FAIL,
  axis,
  payload: error,
});

const updateOrderStatusMapSuccess = (axis, payload) => ({
  type: UPDATE_ORDER_STATUS_MAP_SUCCESS,
  axis,
  payload,
});

export const fetchOrderStatusMap = ({ storageId, axis }) => async (dispatch) => {
  dispatch(fetchOrderStatusMapStart(axis));
  try {
    const response = await get(`/orders-storage/${storageId}/status-maps/${axis}`);
    dispatch(fetchOrderStatusMapSuccess(axis, response.data));
  } catch (e) {
    dispatch(fetchOrderStatusMapFail(axis, e));
  }
};

export const updateOrderStatusMap = ({ storageId, axis, statusMap }, translations) =>
  async (dispatch) => {
    try {
      await put(`/orders-storage/${storageId}/status-maps`, { axis, statusMap });
      dispatch(updateOrderStatusMapSuccess(axis, { axis, statusMap }));
      Store.addNotification(COMMON_DATA_UPDATE_SUCCESS(translations));
      return true;
    } catch (e) {
      Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
      return false;
    }
  };
